<template>
  <div>
    <ChannelHeader
      :image="channel && channel.icons ? channel.icons.dark : ''"
      icon-color="#009F3F"
      background-color="#f8fffb"
      :link="channel.learnMoreLink"
      title="WhatsApp"
      :active="channel.active"
      @activate="activate"
      @deactivate="deactivate" />

    <template v-if="channel.active">
      <h3>Tools</h3>
      <div
        v-for="(item, index) in settingsItems"
        :key="index"
        class="item flex"
        @click="routeTo(item)" >
        <SBIcon
          class="mr-2"
          :icon="item.icon"
          :color="SBColors.blackPrimary"
          :size="14" />
        <p class="mr-2 greedy ellipsis">{{ item.label }}</p>
        <SBIcon
          class="hover-arrow"
          :icon="SBIconList.ARROW_LONG"
          :color="SBColors.greyPrimary"
          :size="14" />
      </div>
    </template>
    <ConnectFeature
      v-else
      :image="channel.icons ? channel.icons.dark : null"
      :connect-text="channel.startNewText"
      icon-background="#fff8fa" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import ChannelHeader from './ChannelHeader';
import ConnectFeature from './ConnectFeature';

export default {
  name: 'WhatsAppChannel',
  components: {
    ChannelHeader,
    SBIcon,
    ConnectFeature,
  },
  data() {
    return {
      settingsItems: [
        {
          label: 'Automated responses (legacy)',
          icon: SBIconList.AUTOMATED,
          target: 'AutomatedResponsesSettings',
        },
        {
          label: 'Message Templates',
          icon: SBIconList.DOC_DARK,
          target: 'MessageTemplates',
        },
        {
          label: 'Profile info',
          icon: SBIconList.PROFILE_FILLED_CIRCLE,
          target: 'WhatsAppProfile',
        },
      ],
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      channelsDataRegistry: 'organisation/channelsDataRegistry',
      currentOrganisation: 'organisation/currentOrganisation',
    }),
    business() {
      return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.businessId);
    },
    channel() {
      let cData = {};
      const cReg = this.channelsDataRegistry.find(cdr => cdr.code === 'whatsapp');
      if (cReg) {
        cData = {
          active: !!cReg.organisation_specific_data.business[this.$route.params.businessId].find(wa => wa.connected), //!!this.business[cReg.code],
          label: cReg.name,
          icons: cReg.icons,
          startNewText: cReg.data.connect_description,
          learnMoreLink: cReg.data.number_blog_url,
          channelUrl: cReg.data.web_app_url,
        };
      }
      return cData;
    },
  },
  methods: {
    activate() {

    },
    deactivate() {
      this.$confirmPluginModal.show({
        buttonVariant: 'BLUE',
        title: 'Disconnect channel',
        message: `In order to disconnect number <b>${this.$options.filters.phoneFormat(this.business.phone)}</b> from WhatsApp please contact our support.`,
        confirmButtonText: 'Contact support',
        showUndoWarning: false,
        confirmCallback: () => {
          const mail = document.createElement('a');
          mail.href = 'mailto:support@ainumber.com';
          mail.target = '_blank';
          mail.click();
          this.$confirmPluginModal.close();
        },
      });
    },
    routeTo(item) {
      if (item.target) {
        this.$router.push({
          name: item.target,
        });
      } else {
        console.warn('Not implemented yet...');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 35px;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;
}

.item {
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px $greyBorder;
  background-color: $white;

  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackPrimary;
  }

  .hover-arrow {
    display: none;
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);

    .hover-arrow {
      display: initial;
    }
  }
}
</style>
